import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider,
  Grid,
  Chip,
  Tooltip,
  Fade,
  Zoom,
} from "@mui/material";
import {
  Close,
  LocalOffer,
  ShoppingBag,
  InfoOutlined,
  CameraAlt,
} from "@mui/icons-material";

import PDFURL from "../../../../../pages/Utils/pdfurl";
import MaterialButton from "../../../../../components/MaterialButton";
import BASEURL from "../../../../../pages/Utils/Baseurl";
import { UpdateRemarkStatus } from "../data";
import Swal from "sweetalert2";
import request from "graphql-request";
import { useLoading } from "../../../../../context/LodingContext";

const AgreedProductPopUp = ({
  open,
  setOpen,
  productDatas,
  fetchMallListData,
  tabValue,
}) => {
  const handleClose = () => setOpen(false);
  const { setCirleLoading } = useLoading();

  const data = productDatas || {};

  const handleremarkstatus = async (id, values) => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, UpdateRemarkStatus, {
        input: {
          remarkId: Number(id),
          status: values,
        },
      });

      const success = res.UpdateRemarkStatus.success;
      const message = res.UpdateRemarkStatus.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: success ? "success" : "error",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          fetchMallListData();
          setOpen(false);
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        }).then(() => {});
      }
    } catch (error) {
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 5,
          p: 0,
          overflow: "hidden",
          backdropFilter: "blur(12px)",
          background: "rgba(255, 255, 255, 0.8)",
          boxShadow: "0 8px 40px rgba(0,0,0,0.15)",
          height: "90vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "linear-gradient(90deg, #2a9941, #44b36b)",
          color: "#fff",
          py: 2,
          px: 3,
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <ShoppingBag sx={{ fontSize: 26 }} />
          <Typography variant="h6" fontWeight={700}>
            Product Overview
          </Typography>
        </Box>
        <IconButton
          onClick={handleClose}
          sx={{
            color: "#fff",
            "&:hover": { background: "rgba(255,255,255,0.15)" },
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent
        sx={{
          flex: 1,
          overflow: "hidden",
          p: 4,
          background:
            "linear-gradient(135deg, #f7fdf8 0%, #ffffff 50%, #f3fff6 100%)",
        }}
      >
        <Box sx={{ padding: "10px 0px" }}>
          <Grid container spacing={4}>
            {/* Left Section — Product Info */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  p: 3,
                  borderRadius: 4,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                  transition: "0.3s",
                  "&:hover": { boxShadow: "0 8px 30px rgba(0,0,0,0.15)" },
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#2a9941", mb: 1, fontWeight: 700 }}
                >
                  PRODUCT DETAILS
                </Typography>
                <Typography variant="h6" fontWeight={700}>
                  {data?.product?.productName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Code: {data?.product?.productCode}
                </Typography>

                <Chip
                  icon={<LocalOffer />}
                  label={data?.product?.productBrand}
                  color="success"
                  variant="outlined"
                  sx={{ mt: 2 }}
                />

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2">
                  Category: <b>{data?.product?.productCategory}</b>
                </Typography>
                <Typography variant="body2">
                  Quantity: <b>{data?.quantity}</b>
                </Typography>

                <Box
                  mt={1}
                  p={2}
                  borderRadius={3}
                  sx={{
                    backgroundColor: "#e9f8ed",
                    boxShadow: "inset 0 0 8px rgba(0,0,0,0.05)",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle2" color="text.secondary">
                      MALL & REMARK
                    </Typography>
                    <Chip
                      size="small"
                      label={
                        data?.remark?.approvedStatus
                          ? data?.remark?.approvedStatus.toUpperCase()
                          : "UNKNOWN"
                      }
                      color={
                        data?.remark?.approvedStatus === "approved"
                          ? "success"
                          : "warning"
                      }
                      sx={{ mt: 1 }}
                    />
                  </Box>

                  <Typography variant="body2" mt={1}>
                    <b>Mall:</b> {data?.mallEntry?.marketName}
                  </Typography>
                  <Typography variant="body2">
                    <b>Remark:</b> {data?.remark?.text || "N/A"}
                  </Typography>

                  {tabValue != "myentry" && (
                    <Box
                      sx={{
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        onClick={() =>
                          handleremarkstatus(
                            productDatas?.remark?.id,
                            "approved"
                          )
                        }
                      >
                        Accept
                      </MaterialButton>
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        onClick={() =>
                          handleremarkstatus(
                            productDatas?.remark?.id,
                            "rejected"
                          )
                        }
                      >
                        Reject
                      </MaterialButton>
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Right Section — Reconciliation */}
            <Grid item xs={12} md={7}>
              <Box
                sx={{
                  p: 3,
                  borderRadius: 4,
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "#2a9941", mb: 2, fontWeight: 700 }}
                  >
                    RECONCILIATION DETAILS
                  </Typography>
                  <Chip
                    size="small"
                    label={
                      data?.reconciliation?.status ? "Above 95%" : "Below 95%"
                    }
                    color={data?.reconciliation?.status ? "success" : "error"}
                  />
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                      <b>Actual Qty:</b> {data?.reconciliation?.actualQuantity}
                    </Typography>
                    <Typography variant="body2">
                      <b>Retail Price:</b> ₹{data?.reconciliation?.retailPrice}
                    </Typography>
                    <Typography variant="body2">
                      <b>Batch Expiry:</b> {data?.reconciliation?.batchExpiry}
                    </Typography>
                  </Grid>

                  {/* Image Comparison */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={2}
                  >
                    {[
                      {
                        label: "Before",
                        src: data?.reconciliation?.imageBefore
                          ? `${PDFURL}/media/${data?.reconciliation?.imageBefore}`
                          : null,
                      },
                      {
                        label: "After",
                        src: data?.reconciliation?.imageAfter
                          ? `${PDFURL}/media/${data?.reconciliation?.imageAfter}`
                          : null,
                      },
                    ].map((img, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          position: "relative",
                          borderRadius: 3,
                          overflow: "hidden",
                          width: 160,
                          height: 160,
                          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                          "&:hover .overlay": { opacity: 1 },
                        }}
                      >
                        <img
                          src={img.src}
                          alt={img.label}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                        <Box
                          className="overlay"
                          sx={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(0,0,0,0.5)",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            opacity: 0,
                            transition: "0.3s",
                          }}
                        >
                          <CameraAlt sx={{ mb: 1 }} />
                          <Typography variant="body2">{img.label}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AgreedProductPopUp;
